import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { Input as AntdInput } from "antd";
import isequal from "lodash.isequal";
import { INPUT_PLACEHOLDER } from "../../modules/language";
import { getMessageString } from "../../tools";

const InputBase = (props) => {
  const {
    intl,
    className: propClass,
    value: propsValue,
    onChange: onChangeProps,
    onFocus: onFocusProps,
    onBlur: onBlurProps,
    prefix,
    placeholder: placeholderProps,
    disabled,
    marker,
  } = props;
  const [inputValue, setInputValue] = useState(propsValue);
  const [inputProps, setInputProps] = useState(null);
  const [hasFocus, setHasFocus] = useState(false);
  const required = marker.isRequired;

  useEffect(() => {
    if (propsValue !== inputValue) {
      setInputValue(propsValue);
      if (!propsValue || propsValue === undefined) setHasFocus(false);
    }
  }, [propsValue, inputValue]);

  useEffect(() => {
    const { className, placeholder, onChange, onFocus, onBlur, allowClear, value, ...inputPropsCopy } =Object.assign({}, props); //prettier-ignore
    const fullClassName = propClass !== undefined ? "ldInput " + propClass : "ldInput";
    inputPropsCopy.className = fullClassName;
    if (!isequal(inputPropsCopy, inputProps)) setInputProps(inputPropsCopy);
    // eslint-disable-next-line
  }, [inputProps, props]);

  const onChangeValue = (e) => {
    let tempE = Object.assign({}, e);
    let allowChange = null;
    const regSpace = /^\s\s$/;
    const value = e.target !== undefined ? e.target.value : e;
    if (value && value !== undefined) {
      if ((!inputValue || inputValue === undefined) && value === " ") setInputValue(null);
      else {
        const substr1 = value.substr(value.length - 1);
        const substr2 = value.substr(value.length - 2);
        if (!(substr1 === " " && regSpace.test(substr2))) {
          setInputValue(value);
          allowChange = true;
        }
      }
    } else {
      if (!value) {
        setInputValue(value);
        tempE.target = { value: null };
        allowChange = true;
      }
    }
    if (onChangeProps && onChangeProps !== undefined && allowChange) onChangeProps(tempE);
  };

  const onBlurChange = (e) => {
    let tempE = Object.assign({}, e);
    if (inputValue && inputValue !== undefined) tempE.target.value = inputValue.trim();
    else tempE.target = { value: null };
    if (hasFocus) setHasFocus(false);
    if (inputValue && inputValue !== undefined && tempE.target.value !== inputValue) onChangeValue(tempE);
    if (onBlurProps && onBlurProps !== undefined) onBlurProps(tempE);
  };

  const onFocusChange = (e) => {
    if (!hasFocus) setHasFocus(true);
    if (onFocusProps && onFocusProps !== undefined) onFocusProps(e);
  };

  let labelClassName = "ldInputLabel";
  if (hasFocus || (inputValue && inputValue !== undefined && inputValue !== "")) labelClassName += " inputActive";
  if (prefix !== undefined) labelClassName += " inputWithPrefix";
  if (disabled !== undefined && disabled === true) labelClassName += " ldInputLabelDisabled";
  //prettier-ignore
  return (
    <div className="inputContent">
      <div className={labelClassName}>
        {required && <span className="requiredInput">*</span>}
        {placeholderProps === undefined ? getMessageString(intl, INPUT_PLACEHOLDER) : placeholderProps}
      </div>
      <AntdInput value={inputValue} onChange={onChangeValue} onFocus={onFocusChange} onBlur={onBlurChange} allowClear {...inputProps} />
    </div>
  );
};

export const Input = injectIntl(InputBase);
